'use client';

import MainPageSimpleLanguageSelector from './MainPageSimpleLanguageSelector';
import Link from 'next/link';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { PiTelegramLogoLight } from 'react-icons/pi';

const MainFooter = () => {
  const { t } = useTranslation();

  // Get translations (async updates in background)
  const labels = {
    articles: t('footer.articles'),
    startLearning: t('homePage.startLearning'),
    contactUs: t('footer.contactUs'),
    contactUsOn: t('footer.contactUsOn'),
    telegram: t('footer.telegram'),
    copyright: t('footer.copyright'),
  };

  return (
    <footer className='w-full bg-white border-t pt-10 flex flex-col items-center justify-between'>
      <div className='w-full flex flex-row justify-between items-center gap-2.5'>
        {/* Logo */}
        <div className='flex items-center'>
          <Link href='/' className='text-base font-medium'>
            DarPiano
          </Link>
        </div>

        {/* Telegram - Mobile: icon + text only, Desktop: with prefix */}
        <div className='flex gap-2 items-center'>
          <span className='hidden md:inline'>{labels.contactUsOn}</span>
          <Link
            href='https://t.me/darpianocom'
            className='flex items-center gap-1'
            target='_blank'
            rel='noopener noreferrer'
            aria-label='Telegram'
          >
            <div className='pr-0.5'>
              <PiTelegramLogoLight size={20} />
            </div>
            {labels.telegram}
          </Link>
        </div>

        {/* Language Selector */}
        <div className='flex items-center'>
          <Suspense fallback={<div className='flex gap-2 items-center px-0.5 text-base'>EN</div>}>
            <MainPageSimpleLanguageSelector />
          </Suspense>
        </div>
      </div>
    </footer>
  );
};

export default MainFooter;
